/// <reference path="../../../../tools/typings/tsd.d.ts"/>

module DealerwareWebContent {

    "use strict";
    import IDealerwareCustomer = DealerwareWebServices.IDealerwareCustomer;
    import IDealerwareLocation = DealerwareWebServices.ILocation;
    import IDealerwareLocationSettings = DealerwareWebServices.ILocationSettings;

    var isFunction  = angular.isFunction;

    export interface ICustomerDetailsController {
        defaultPage: string;
        customer: IDealerwareCustomer;
        location: IDealerwareLocation;

        loadCustomer(id: number) : void;
        loadLocationSettings() : ng.IPromise<{}>;
        loadDriversLicense() : ng.IPromise<{}>;
        loadPaymentMethod() : ng.IPromise<{}>;
        loadPaymentProcessor() : ng.IPromise<{}>;
        loadNotes() : ng.IPromise<{}>;
        loadContracts() : ng.IPromise<{}>;
        createContract() : void;
        saveInsurance(insurance: any, deleteInsuranceImage: boolean) : ng.IPromise<{}>;
    }

    export class CustomerDetailController implements ICustomerDetailsController {
        public static $inject : string[] = [
            '$q',
            '$timeout',
            '$state',
            '$stateParams',
            '$dealerwareCustomerFactory',
            'LocationFactory',
            '$mobilityCompanyAuthentication',
            '$dealerwareNotification',
            '$dealerwareLoading',
            '$dealerwareInternationalizationData'
        ];

        public defaultPage: string;
        public customer : IDealerwareCustomer;
        public location: IDealerwareLocation = <IDealerwareLocation>{};
        public labels: {};
        public noteSummary: string;
        public contractSummary: string;

        constructor(public $q: any,
                    public $timeout : any,
                    public $state: any,
                    public $stateParams : any,
                    public $dealerwareCustomerFactory : any,
                    public LocationFactory: any,
                    public $mobilityCompanyAuthentication: any,
                    public $dealerwareNotification: any,
                    public $dealerwareLoading: any,
                    public $dealerwareInternationalizationData: any) {

            this.getLabels('customers');

            this.location = this.LocationFactory.getInstance();

            if (this.$stateParams.hasOwnProperty('customerId')) {
                this.loadCustomer(this.$stateParams.customerId);
            } else {
                this.$dealerwareNotification.error('No customer id');
            }

            this.defaultPage = this.$stateParams.pageId || 'profile';
        }

        public getLabels(module: string) : void {
            const _self = this;
            this.$dealerwareInternationalizationData
                .getLabels()
                .then( function(res) {
                    _self.labels = _self.$dealerwareInternationalizationData.getLabelsByModule(res.data, module);
                },
                function(error: any) {
                    _self.$dealerwareNotification(error);
                }
            );
        }

        public loadCustomer(id : number) : void {
            this.customer = undefined;

            if (this.$stateParams.hasOwnProperty('customerId')) {
                var loader = this.$dealerwareLoading.show("Loading Customer...");
                this.$dealerwareCustomerFactory.loadCustomer(
                    this.$mobilityCompanyAuthentication.location.id,
                    this.$stateParams.customerId
                ).then(
                    (response : any) => {
                        this.customer = response.customer;

                        this.$q.all([
                            this.loadLocationSettings(),
                            this.loadDriversLicense(),
                            this.loadPaymentMethod(),
                            this.loadPaymentProcessor(),
                            this.loadNotes(),
                            this.loadContracts()
                        ]).then(() => {
                            this.notesSummary();
                            this.contractsSummary();
                            loader.close(); 
                        });
                    },
                    (response: any) => {
                        loader.close();
                        this.$dealerwareNotification.apiError(response);
                    }
                );
            } else {
                this.$dealerwareNotification.error("No customer to load");
            }
        }

        private notesSummary(): void {
            if(!this.customer.noteCollection){
                this.noteSummary = "";
            }
            const summary = this.customer.noteCollection.notes.toSummaryString().split(":");
            this.noteSummary = this.labels.navigation.notes + ":" + (summary[1] || ' 0');
        }

        private contractsSummary(): void {
            if(!this.customer.contracts){
                this.contractSummary = "";
            }
            const summary = this.customer.contracts.toSummaryString().split(":");
            this.contractSummary = this.labels.navigation.contracts + ":" + (summary[1] || ' 0');
        }

        public loadLocationSettings() : ng.IPromise<{}> {
            var _deferred = this.$q.defer();

            if (!this.location.settings) {
                this.LocationFactory.getInstance().loadSettings(this.$mobilityCompanyAuthentication.location.id)
                    .then ( (location : IDealerwareLocation) => {
                        this.location.settings = location.settings;
                        _deferred.resolve({returnValue: location});
                    })
                    .catch ( (response : any) => {
                        _deferred.reject(response);
                    });
            }

            return _deferred.promise;
        }

        public loadDriversLicense() : ng.IPromise<{}> {
            var _deferred = this.$q.defer();

            if (!this.customer.driversLicense) {
                this.customer.loadDriversLicense()
                    .then((response: any) => { _deferred.resolve({response: response}); })
                    .catch((response: any) => { _deferred.reject(response); });
            }

            return _deferred.promise;
        }

        public loadPaymentMethod() : ng.IPromise<{}> {
            var _deferred = this.$q.defer();

            if (!this.customer.creditCards) {
                this.customer.loadCreditCards()
                    .then((response: any) => { _deferred.resolve({response: response}); })
                    .catch((response: any) => { _deferred.reject(response); });
            }

            return _deferred.promise;
        }

        public loadPaymentProcessor() : ng.IPromise<{}> {
            var _deferred = this.$q.defer();

            if (!this.customer.paymentProcessor) {
                this.customer.loadPaymentProcessor()
                    .then((response: any) => { _deferred.resolve({response: response}); })
                    .catch((response: any) => { _deferred.reject(response); });
            }

            return _deferred.promise;
        }

        public loadNotes() : ng.IPromise<{}> {
            var _deferred = this.$q.defer();

            if (!this.customer.noteCollection.isNotesLoaded()) {
                this.customer.loadNotes()
                    .then((response: any) => { _deferred.resolve({response: response}); })
                    .catch((response: any) => { _deferred.reject(response); });
            }

            return _deferred.promise;
        }

        public loadContracts() : ng.IPromise<{}> {
            var _deferred = this.$q.defer();

            if (!this.customer.contracts) {
                this.customer.loadContracts()
                    .then((response: any) => { _deferred.resolve({response: response}); })
                    .catch((response: any) => { _deferred.reject(response); });
            }

            return _deferred.promise;
        }

        public createContract() : void {
            this.$state.go('shortcuts.contractCreate', { customerId: this.customer.accountSettings.data.id });
        }

        public saveInsurance(insurance: any, deleteInsuranceImage: boolean) : ng.IPromise<{}> {
            var _deferred = this.$q.defer(),
                _self = this;

            var loader = this.$dealerwareLoading.show('Saving...');
            this.customer.saveInsurance().then(
                function() {
                    if (deleteInsuranceImage && _self.customer.accountSettings.data.insurance_preferences[0].image) {
                        _self.customer.deleteInsuranceImage().finally(function() {
                            loader.close();
                            _self.$dealerwareNotification.toast('Insurance Saved!');
                            _deferred.resolve();
                        });
                    } else {
                        loader.close();
                        _self.$dealerwareNotification.toast('Insurance Saved!');
                        _deferred.resolve();
                    }
                },
                function(response: any) {
                    loader.close();
                    _self.$dealerwareNotification.apiError(response);
                    _deferred.reject();
                }
            );

            return _deferred.promise;
        }
    }

    getDealerwareWebContentModule().controller('CustomerDetailsController',CustomerDetailController);
}
